import React, { useEffect, useState } from "react";
import AddressForm from "./AddressForm";
import PaymentForm from "./PaymentForm";
import { createSetupIntent } from "../../../api/ShopOrders";

const CheckoutBox = ({
  total,
  productTotal,
  donationTotal,
  localUserData,
  productItems,
  donationItems,
}) => {
  const [step, setStep] = useState(1); // Step 1: Address, Step 2: Payment
  const [clientSecret, setClientSecret] = useState(null);
  const [formValues, setFormValues] = useState({
    address1: "",
    address2: "",
    city: "",
    state: "",
    country: "US",
    zip: "",
    phone: "",
  });

  const [formErrors, setFormErrors] = useState({
    address1: "",
    address2: "",
    city: "",
    state: "",
    country: "",
    zip: "",
    phone: "",
  });

  const [toast, setToast] = useState(null);

  useEffect(() => {
    if (!toast) return;
    const timeout = setTimeout(() => setToast(null), 4000);
    return () => clearTimeout(timeout);
  }, [toast]);

  const showToast = (message) => {
    setToast({ message });
  };

  // Handles creating a set up intent in the backend to start Stripe's payment element in the next step
  const handleAddressSubmit = async () => {
    if (!localUserData) {
      showToast("Please log in to proceed to payment.");
      return;
    }

    try {
      const response = await createSetupIntent();
      if (response) {
        setClientSecret(response.client_secret);
        setStep(2);
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        showToast("Please log in to proceed to payment.");
        return;
      }
      console.error("Error submitting address: ", error);
      showToast("We couldn't start the payment process. Please try again.");
    }
  };

  return (
    <div className="relative bg-blue rounded-xl35 p-8 shadow-cartBoxes">
      {step === 1 && (
        <AddressForm
          handleAddressSubmit={handleAddressSubmit}
          localUserData={localUserData}
          formValues={formValues}
          formErrors={formErrors}
          setFormValues={setFormValues}
          setFormErrors={setFormErrors}
        />
      )}
      {step === 2 && (
        <PaymentForm
          clientSecret={clientSecret}
          productItems={productItems}
          donationItems={donationItems}
          productTotal={productTotal}
          donationTotal={donationTotal}
          formValues={formValues}
          total={total}
        />
      )}
      {toast && (
        <div className="fixed bottom-8 right-8 z-50">
          <div className="bg-red-600 text-white px-4 py-3 rounded shadow-lg min-w-[220px] text-sm font-medium">
            {toast.message}
          </div>
        </div>
      )}
    </div>
  );
};

export default CheckoutBox;
